<template>
  <!--  <div class="row" v-loading="true" id="loading" ></div>-->
  <div v-if="loading" class="custom-loading-mask" id="loading">
    <svg class="custom-spinner" viewBox="0 0 50 50">
      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5" />
    </svg>
  </div>
</template>
<script>
import Vue from 'vue';
import { Loading } from 'element-ui';

Vue.use(Loading.directive);
export default {
  name: 'loading-panel',
  props: {
    loading: Boolean
  },
};
</script>
<style>
#loading {
  min-height: 1000px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-loading-mask {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-spinner {
  animation: rotate 1s linear infinite;
  width: 60px;
  height: 60px;
}

.custom-spinner .path {
  stroke: #c2c1c1;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
}

@keyframes rotate {
  100% { transform: rotate(360deg); }
}

@keyframes dash {
  0% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 120, 150;
    stroke-dashoffset: -45;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -135;
  }
}

</style>
